<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
    >
      <template #header>
        <div class="d-flex align-items-stretch mb-2 mt-2" v-if="!disabled">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('tbale_header_appAccountStore') || '账号店铺' }}
            </span>
            <el-divider direction="vertical" />
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseStoreVisible = true"
            >
              {{ $l('btn_addAccountStore') || '绑定店铺' }}
            </b-button>
          </div>
        </div>
      </template>
    </PageMain>

    <ChooseAmzStore
      :visible.sync="chooseStoreVisible"
      @confirm="chooseStoreConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import ChooseAmzStore from '../choose-amz-store'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, ChooseAmzStore },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    amzAppAccountCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      chooseStoreVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzAppAccountCode) return
      this.loading = true
      const params = { amzAppAccountCode: this.amzAppAccountCode }
      const res = await this.$api
        .ecomAmzAppAccountStoreListApi(params)
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    chooseStoreConfirm(data) {
      const tableData = this.getTableData()
      const $main = this.$refs.main

      if (!data?.length) return
      if (!tableData?.length) {
        $main.insertAt(data)
        return
      }

      // 过滤重复的店铺
      const newTableData = data.filter((item) => {
        const findIndex = tableData.findIndex(
          (row) => row.amzStoreCode === item.amzStoreCode
        )
        return findIndex < 0
      })
      if (!newTableData?.length) {
        return
      }

      $main.insertAt(newTableData)
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
